import {
  DIM_COLOR_MO,
  DIM_COLOR_PC,
  DIM_MOBILE_QUERY,
} from '@/theme/dimTokens';

// ----------------------------------------------------------------------

export default function Backdrop() {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          // Popover/Menu/Select 는 투명 backdrop(.MuiBackdrop-invisible)을 쓰므로
          // 가드 없이 root 를 칠하면 드롭다운 열 때마다 화면이 어두워짐
          '&:not(.MuiBackdrop-invisible)': {
            backgroundColor: DIM_COLOR_PC,
            [DIM_MOBILE_QUERY]: {
              backgroundColor: DIM_COLOR_MO,
            },
          },
        },
      },
    },
  };
}
